<div *ngIf="!modalData.isEdit" [formGroup]="rankingForm" class="mt-1">
  <div class="form-group row">
    <label class="col-2 col-form-label">คำถาม<lifedi-require></lifedi-require></label>
    <div class="col-10">
      <input type="text" class="form-control" id="question" formControlName="question" autocomplete="off"
        ngDefaultControl>
    </div>
  </div>

  <div *ngFor="let c of rankingFormArray.controls; let i = index" formArrayName="choices">
    <div [formGroupName]="i" class="form-group row">
      <label class="col-1 col-form-label">C{{i+1}}<lifedi-require></lifedi-require></label>
      <input class="form-control col-10" formControlName="choice_detail" type="text">
      <button mat-mini-fab class="img col-1" (click)="deleteChoice(rankingFormArray, i)"
        [style.backgroundImage]="'url(\' ../../../../assets/remove.png\')'">
      </button>
    </div>
  </div>

  <button mat-mini-fab class="img col-1" (click)="addChoice(rankingFormArray)"
    [style.backgroundImage]="'url(\' ../../../../assets/add.png\')'">
  </button>
</div>

<div *ngIf="modalData.isEdit" [formGroup]="rankingForm" class="mt-1">
  <div class="form-group row">
    <label class="col-2 col-form-label">คำถาม<lifedi-require></lifedi-require></label>
    <div class="col-10">
      <input type="text" class="form-control" id="question" formControlName="question" autocomplete="off"
        ngDefaultControl>
    </div>
  </div>

  <div *ngFor="let c of rankingFormArray.controls; let i = index" formArrayName="choices">
    <div [formGroupName]="i" class="form-group row">
      <label class="col-1 col-form-label">C{{i+1}}<lifedi-require></lifedi-require></label>
      <input class="form-control col-10" formControlName="choice_detail" type="text">
      <button mat-mini-fab class="img col-1" (click)="deleteChoice(rankingFormArray, i)"
        [style.backgroundImage]="'url(\' ../../../../assets/remove.png\')'">
      </button>
    </div>
  </div>

  <button mat-mini-fab class="img col-1" (click)="addChoice(rankingFormArray)"
    [style.backgroundImage]="'url(\' ../../../../assets/add.png\')'">
  </button>
</div>
